import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, provideHttpClient} from '@angular/common/http';
import {TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG} from '@ngx-translate/http-loader';
import {FrontpageComponent} from './components/frontpage/frontpage.component';
import {StatusComponent} from './components/status/status.component';
import {HeaderComponent} from './components/shared/header/header.component';
import {ConsentComponent} from './components/consent/consent.component';
import {CaseComponent} from './components/case/case.component';
import {ErrorComponent} from './components/error/error.component';
import {DoctorComponent} from './components/doctor/doctor.component';
import {MarkdownModule} from 'ngx-markdown';
import {AcComponent} from './components/ac/ac.component';
import {TemplateComponent} from './components/template/template.component';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {EnvServiceProvider} from './services/env.service.provider';
import {RedirectComponent} from './components/redirect/redirect.component';
import {UserComponent} from './components/user/user.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

export function HttpLoaderFactory() {
  return new TranslateHttpLoader();
}

@NgModule({
  declarations: [
    AppComponent,
    FrontpageComponent,
    StatusComponent,
    HeaderComponent,
    ConsentComponent,
    CaseComponent,
    ErrorComponent,
    DoctorComponent,
    AcComponent,
    TemplateComponent,
    RedirectComponent,
    UserComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    NgSelectModule,
    FormsModule,
    MarkdownModule.forRoot(),
    MatProgressSpinnerModule,
    BrowserAnimationsModule
  ],
  providers: [
    provideHttpClient(),
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    EnvServiceProvider,
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/assets/i18n/',
        suffix: '.json'
      }
    }
  ]
})
export class AppModule {
}
